import * as React from "react";
import type { SVGProps } from "react";
const EllipsisIcon = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="1em" height="1em" fill="none" style={{
  userSelect: "none",
  flexShrink: 0
}} {...props}><path fill="currentColor" d="M7 20a1 1 0 1 1-2 0 1 1 0 0 1 2 0M13 20a1 1 0 1 1-2 0 1 1 0 0 1 2 0M19 20a1 1 0 1 1-2 0 1 1 0 0 1 2 0" /></svg>;
export default EllipsisIcon;